import { Colors, fontMedium } from "swing-components";

import {
  ModalCancelCommitmentsBody,
  ModalCancelCommitmentsFooter,
  ModalCancelCommitmentsHeader,
  RadioInput,
} from "~components";
import { msg } from "~utils";

import {
  type CancellationType,
  type ModalCancelCommitmentsStep,
  type PenaltyAlert,
} from "../ModalCancelCommitments";

type ModalCancelCommitmentsCancellationTypeProps = {
  penaltyType: PenaltyAlert;
  setStep: (step: ModalCancelCommitmentsStep) => void;
  onDismiss: () => void;
  cancellationType?: CancellationType;
  setCancellationType: (cancellationType: CancellationType) => void;
};

export function ModalCancelCommitmentsCancellationType(
  props: ModalCancelCommitmentsCancellationTypeProps,
) {
  const { penaltyType, setStep, onDismiss, cancellationType, setCancellationType } = props;

  return (
    <div className="modal-wrapper">
      <ModalCancelCommitmentsHeader onDismiss={onDismiss} />
      <ModalCancelCommitmentsBody penaltyType={penaltyType}>
        <p css={fontMedium({ fontWeight: 600 })}>
          {msg("CANCEL_COMMITMENT_MODAL_CANCELLATION_TYPE_MESSAGE")}
        </p>
        <div css={{ padding: "16px 24px", borderBottom: `1px solid ${Colors.slate200}` }}>
          <RadioInput
            isSelected={cancellationType === "CANCEL_PARTIAL_REQUEST"}
            onChange={(value) => setCancellationType(value as CancellationType)}
            value="CANCEL_PARTIAL_REQUEST"
            label={msg("CANCEL_COMMITMENT_MODAL_PARTIAL_REQUEST")}
          />
        </div>
        <div css={{ padding: "16px 24px", borderBottom: `1px solid ${Colors.slate200}` }}>
          <RadioInput
            isSelected={cancellationType === "CANCEL_FULL_REQUEST"}
            onChange={(value) => setCancellationType(value as CancellationType)}
            value="CANCEL_FULL_REQUEST"
            label={msg("CANCEL_COMMITMENT_MODAL_FULL_REQUEST")}
          />
        </div>
      </ModalCancelCommitmentsBody>
      <ModalCancelCommitmentsFooter
        buttonPrimary={{
          isDisabled: !cancellationType,
          text: msg("LABEL_NEXT"),
          onClick: () => {
            if (!cancellationType) return;
            setStep(
              cancellationType === "CANCEL_PARTIAL_REQUEST"
                ? "partial-cancel-days"
                : "cancellation-reason",
            );
          },
        }}
        buttonSecondary={{
          isDisabled: false,
          text: msg("CANCEL_COMMITMENT_MODAL_BUTTON_CANCEL"),
          onClick: onDismiss,
        }}
      />
    </div>
  );
}
